

















import * as _ from 'lodash';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { VBPopover } from 'bootstrap-vue';
import { ShortCutIcon } from '../../types/Interface';
import { redirect } from '../../scripts/utils/redirect';


@Component({
  components: {
  },
  directives: { 'b-popover': VBPopover },
})
export default class Shortcut extends Vue {
  private redirect: Function = (title: string) => { redirect(title, this); };

  @Prop({ required: true }) data!: ShortCutIcon;


  public mounted() {
  }
}
